// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"751":"99a3f1d0","780":"0f43f0b8"}[chunkId] + ".chunk.js";
};